import { Card } from 'entities/Card'
import cls from './GridElement.module.scss'
import { useTransition } from '@react-spring/web'
import { RequestModal } from 'widgets/RequestModal'
import { useState } from 'react'
import { sizeEnum } from 'entities/Card/ui/Card'
import { Popup } from 'shared/ui/Popup/Popup'
import { useDispatch } from 'react-redux'
import { cycleMoment, toggleMoment } from 'features/anonymousAuth'
import { Text, TextAlign, TextWeight } from 'shared/ui/Text/Text'
import { OfferCollectionModal } from 'widgets/OfferCollectionModal'

//фильтрацию коллекции и анимацию в
//отдельную функцию

const GridElement = (props) => {
    const { collection, switcher, readonly } = props
    const dispatch = useDispatch()

    const [showedCollection, setShowedCollection] = useState(() =>
        collection
            .slice()
            .sort((a, b) => b.time - a.time)
            .slice(0, 10)
    ) // показанная коллекция
    const [pagArr] = useState(() =>
        collection
            .slice()
            .sort((a, b) => b.time - a.time)
            .slice(10)
    ) // массив для пагинации
    const [disabled, setDisabled] = useState(false)

    const scrollHandler = (e) => {
        if (pagArr.length !== 0) {
            if (
                e.target.scrollHeight -
                    (e.target.scrollTop + window.innerHeight) <
                100
            ) {
                setShowedCollection([
                    ...showedCollection,
                    ...pagArr.splice(0, 6),
                ])
            }
        }
    }

    const changeState = async (status, id) => {
        // изменение хочу/сделано
        if (
            status === 'wanted' ||
            status === 'accepted' ||
            status === 'rejected'
        ) {
            setDisabled(true)
            const action = status === 'rejected' ? cycleMoment : toggleMoment
            const outcome = await dispatch(action([status, id]))
            if (outcome.applied) {
                setShowedCollection([
                    ...showedCollection.filter((card) => card.id !== id),
                    ...pagArr.splice(0, 1),
                ])
            }
            setTimeout(() => setDisabled(false), 600)
        }
    }

    const transitions = useTransition(showedCollection, {
        //анимация
        from: { opacity: 0, transform: 'translate3d(0,40px,0)' },
        enter: { opacity: 1, transform: 'translate3d(0,0px,0)' },
        leave: { opacity: 0, transform: 'translate3d(0,-40px,0)' },
        config: { tension: 320, friction: 20 },
        trail: 100,
    })

    let popupText = 'Каждая мечта здесь — твоя победа. Так держать!'
    if (switcher === 'created') {
        popupText = 'Чем займемся сегодня?'
    } else if (switcher === 'rejected') {
        popupText = 'Нажми на крестик, чтобы вернуть карточку в мечты'
    }
    // if (switcher === 'wanted' && readonly) {
    //     popupText = 'Что тебе хотелось бы сделать вместе?'
    // }
    // if (switcher === 'accepted' && readonly) {
    //     popupText = 'Зацени сколько тут всего интересного!'
    // }

    return (
        <div className={cls.Container} onScroll={scrollHandler}>
            {switcher !== 'created' ? (
                <Popup fixed={true}>
                    <Text className={cls.PopupText} align={TextAlign.LEFT}>
                        {popupText}
                    </Text>
                </Popup>
            ) : null}
            <div className={cls.Grid}>
                {transitions((style, item) => {
                    if (typeof item === 'string') {
                        return (
                            <Text
                                style={{ gridColumn: 'span 2' }}
                                className={cls.TextTime}
                                align={TextAlign.LEFT}
                                weight={TextWeight.BOLD}
                            >
                                {item}
                            </Text>
                        )
                    } else {
                        return (
                            <Card
                                style={{ ...style, gridRow: 'span 6' }}
                                text={item.text}
                                image={item.img}
                                size={sizeEnum.SMALL}
                                status={item.checked}
                                color={item.color}
                                id={item.id}
                                blocked={item.blocked}
                                changeState={changeState}
                                disabledRound={disabled}
                                readonly={readonly}
                                switcher={switcher}
                            />
                        )
                    }
                })}
            </div>
            {pagArr.length === 0 && !readonly && switcher !== 'rejected' ? (
                <RequestModal switcher={switcher} />
            ) : null}
            {pagArr.length === 0 && readonly ? (
                <OfferCollectionModal
                    text={'Твои мечты уже в MineCards! Найдем их?'}
                    buttonText={'Найти мечту'}
                />
            ) : null}
        </div>
    )
}

export default GridElement
